export default {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SET_VISIBLE_CATEGORIES(state, categories) {
    state.visibleCategories = categories;
  },
  SET_CREATABLE_CATEGORIES(state, categories) {
    state.creatableCategories = categories;
  }
};
